import { render, staticRenderFns } from "./instockManage.vue?vue&type=template&id=8b9be132&scoped=true&"
import script from "./instockManage.vue?vue&type=script&lang=js&"
export * from "./instockManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b9be132",
  null
  
)

export default component.exports